import { component } from 'picoapp';
import { merge } from 'lodash';
const Flickity = require('flickity');
import wheel from 'wheel';
import normalizeWheel from 'normalize-wheel';
import { str2json, getClosest } from '@utils';
//import './component.scss';

class Slider {
  constructor(el, ctx) {
    this._init(el);
    this.ctx = ctx;
    this.bindEvents();
  }

  _init(el) {
    this.el = el;
    this.identifier = el.dataset.identifier;

    this.defaults = {
      autoPlay: false,
      contain: true,
      customUI: false,
      draggable: true,
      cellContainer: null,
      cellSelector: '.Slider__item',
      cellAlign: 'left',
      prevNextButtons: true,
      pageDots: true,
      groupCells: false,
      wrapAround: true,
      wheelControl: false,
      arrowShape:
        'M72.8536585,8.13157895 C71.420864,6.6334674 69.0318491,6.6334674 67.1219512,8.13157895 L28.1463415,47.7368421 C26.631552,48.8114676 26.631552,51.1880631 28.1463415,52.2631579 L67.1219512,91.8684211 C68.2940096,92.6339367 69.258296,93 70.5609756,93 C71.190643,93 72.1568165,92.6339367 72.8536585,91.8684211 C74.368448,90.4338025 74.368448,88.0572069 72.8536585,86.2105263 L36.1707317,50 L72.8536585,13.7894737 C74.3665609,11.9423237 74.3665609,9.56572822 72.8536585,8.13157895 L72.8536585,8.13157895 Z',
    };

    this.options = merge(this.defaults, str2json(this.el.dataset.options));

    this.sliderLoaded = false;

    this.breakpoint = this.el.dataset.breakpoint ? this.el.dataset.breakpoint : 'all'

    if (this.options.cellContainer) {
      this.sliderWrapper = this.el.querySelector(this.options.cellContainer);
    } else {
      this.sliderWrapper = this.el;
    }

    if (this.options.customUI) {
      this.options = { ...this.options, prevNextButtons: false };
    }
    if (this.options.mobileAlign && window.innerWidth < 768) {
      this.options = { ...this.options, cellAlign: "center" };
    }
    if (this.options.useStaticCaption) {
      this.captionTarget = this.el.parentNode.querySelector('.captionTarget');
      this.slidesCaptions = this.el.querySelectorAll('.Slider__item .Slider__content');
      this.captionTarget.innerHTML = this.slidesCaptions[0].innerHTML;
    }

    this.parentControllerEl = getClosest(this.el, '.js-sliderController');
    el.classList.remove('is-hidden');
    // trigger redraw for transition
    el.offsetHeight;

    if (this.breakpoint == 'mobile' && window.innerWidth < 768) {
      this.sliderEl = new Flickity(this.sliderWrapper, this.options);
      this.sliderLoaded = true;
    } else if (this.breakpoint != 'mobile') {
      this.sliderEl = new Flickity(this.sliderWrapper, this.options);
      this.sliderLoaded = true;
    }

    if (this.options.customUI) {
      this.initCustomUI(this.sliderEl);
    }
  }

  initCustomUI(slider) {
    const containerEl = this.options.referenceElement ? getClosest(this.el, this.options.referenceElement) : this.el.parentNode;

    // previous
    var previousButton = containerEl.querySelector('.Button--previous');
    if (previousButton) {
      previousButton.addEventListener('click', () => {
        this.sliderEl.previous();
      });
    }

    // next
    var nextButton = containerEl.querySelector('.Button--next');
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        this.sliderEl.next();
      });
    }
    
    
    if(!this.options.wrapAround){ 
      // initial state
      if (this.sliderEl.selectedIndex == 0) {
        previousButton.setAttribute('disabled', 'disabled')
      } else {
        previousButton.removeAttribute('disabled')
      }
      if (this.sliderEl.selectedIndex == this.sliderEl.cells.length - 1) {
        nextButton.setAttribute('disabled', 'disabled')
      } else {
        nextButton.removeAttribute('disabled')
      }

      // update state on slide change
      this.sliderEl.on('change', (index, pointer) => {
        if (index == 0) {
          previousButton.setAttribute('disabled', 'disabled')
        } else {
          previousButton.removeAttribute('disabled')
        }
        if (index == this.sliderEl.cells.length - 1) {
          nextButton.setAttribute('disabled', 'disabled')
        } else {
          nextButton.removeAttribute('disabled')
        }
      });
    }
  }

  tagPrevNext(index) {

    const cells = this.sliderEl.getCellElements();
    const next = index == cells.length - 1 ? 0 : index + 1
    const previous = index == 0 ? cells.length - 1 : index - 1

    cells.forEach(el => {
      if (el == cells[previous]) {
        el.classList.add('previous');
      } else {
        el.classList.remove('previous');
      }
      if (el == cells[next]) {
        el.classList.add('next');
      } else {
        el.classList.remove('next');
      }
    })
  }

  bindEvents() {
    window.addEventListener('load', () => {
      if (this.sliderEl) {
        this.sliderEl.resize();
        this.tagPrevNext(0);
        if (this.breakpoint == 'mobile' && window.innerWidth > 768) {
          this.sliderEl.destroy();
          this.sliderLoaded = false;
        }
      }
    });

    window.addEventListener('resize', () => {
      if (this.breakpoint == 'mobile' && window.innerWidth > 768) {
        if (this.sliderLoaded) {
          this.sliderEl.destroy();
          this.sliderLoaded = false;
        }
      } else {
        if (!this.sliderLoaded) {
          this.sliderEl = new Flickity(this.el, this.options);
          this.sliderLoaded = true;
          this.sliderEl.on('change', (index) => this.tagPrevNext(index));
          if (this.options.customUI) {
            this.initCustomUI(this.sliderEl);
          }
        }
      }
      if (this.sliderEl) {
        this.tagPrevNext(this.sliderEl.selectedIndex);
        this.sliderEl.on('change', (index) => {
          this.ctx.emit('slideChange', { el: this.el, cell: index })
        })
      }
      if (this.sliderEl && this.options.mobileAlign == 'center' && this.options.cellAlign == 'left' && window.innerWidth < 768) {
        this.sliderEl.destroy();
        this.options = { ...this.options, cellAlign: "center" };
        this.sliderEl = new Flickity(this.el, this.options);
      } else if (this.sliderEl && this.options.mobileAlign == 'center' && this.options.cellAlign == 'center' && window.innerWidth >= 768) {
        this.sliderLoaded = false;
        this.sliderEl.destroy();
        this.options = { ...this.options, cellAlign: "left" };
        this.sliderEl = new Flickity(this.el, this.options);
      }
    })

    if (this.parentControllerEl) {
      if (this.sliderEl) {
        jQuery(this.parentControllerEl).on('isActive', (e) => {
          this.sliderEl.resize();
        });
      }
    }

    if (this.options.wheelControl && this.sliderEl) {
      wheel.addWheelListener(this.sliderEl.element, (event) => {
        event.preventDefault();
        const wheelNormalized = normalizeWheel(event);
        this.sliderEl.applyForce(-wheelNormalized.pixelY / 4);
        this.sliderEl.startAnimation();
        this.sliderEl.dragEnd();
      });
    }

    if (this.sliderEl) {
      this.sliderEl.on('staticClick', function (event, pointer, cellElement, cellIndex) {
        if (!cellElement) {
          return;
        }
        if (typeof event.target.click === 'function') {
          event.target.click();
        }
      });
      this.sliderEl.on('change', (index) => this.tagPrevNext(index));
      if (this.identifier && this.identifier == 'video-slider') {
        this.sliderEl.on('change', (index) => this.ctx.emit('video-slider-change'));
      }

    }
    if (this.sliderEl && this.options.useStaticCaption) {
      this.sliderEl.on('change', (index) => {
        this.captionTarget.innerHTML = this.slidesCaptions[index].innerHTML;
      })
    }


  }
}

// module.exports = Slider;
export default component((node, ctx) => {
  new Slider(node, ctx);
});
